import { Navigate, useLocation } from 'react-router-dom';
import { isMobile, isTablet } from 'react-device-detect';
import { ROUTES } from '../routes';

/**
 * Default redirect component for the index route (/transcribe)
 * - Mobile users (excluding tablets) are redirected to history page
 * - Desktop users are redirected to home page
 * - Preserves URL search params (e.g. api_host, sessionId) so session init can write to localStorage
 */
function MobileDefaultRedirect() {
  const location = useLocation();
  const isMobileDevice = isMobile && !isTablet;
  const target = isMobileDevice ? ROUTES.HISTORY : ROUTES.HOME;

  return <Navigate to={`${target}${location.search}`} replace />;
}

export default MobileDefaultRedirect;

